import { memo } from "react";
import Box, { type BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const UploadDocumentsList = (props: BoxProps) => (
    <Box
        {...props}
    >
        <Typography
            gutterBottom
            variant='h6'
        >
            Please prepare the following documents for upload:
        </Typography>
        <Box
            component='ul'
            sx={{
                minWidth: 'max-content',
                pl: 3
            }}
        >
            {[
                'Certificate of Incorporation',
                'Memorandum',
                'Articles of Association',
                'Company Account Bank Statement',
                'Copy of your licence',
                'Bank reference',
                'Proof of Domain Ownership',
                'Passports of shareholders',
                'Utility Bill of Shareholders'
            ].map((item, index) => (
                <Box
                    component='li'
                    key={index}
                >
                    {item}
                </Box>
            ))}
        </Box>
    </Box>
);

export default memo(UploadDocumentsList);
